var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import ComponentModel from '../../model/componentModel';
import { Group, Rect, Polyline, createText } from '../../element/index';
import * as lodash from '../../utils/lodash';
import CalendarCoordinate from '../../coord/calendar';
import measureText from '../../utils/measureText';
var Calendar = /** @class */ (function (_super) {
    __extends(Calendar, _super);
    function Calendar() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = 'calendar';
        return _this;
    }
    Calendar.prototype.getDefaultOption = function () {
        return {
            cellSize: 20,
            facet: 0,
            dateRange: [null, null],
            firstDay: 0,
            cellStyle: {
                fill: '#ffffff',
                stroke: '#ebebeb',
                lineWidth: 1,
            },
            dayLabel: {
                show: true,
                opposite: false,
                margin: 12,
                textStyle: {
                    color: '#999999',
                    fontSize: 12,
                },
            },
            monthLabel: {
                show: true,
                opposite: false,
                margin: 12,
                textStyle: {
                    color: '#999999',
                    fontSize: 12,
                },
            },
            monthBoundary: {
                show: false,
                lineStyle: {
                    stroke: '#1A1E22',
                    lineWidth: 1,
                },
            },
        };
    };
    Calendar.prototype.getInitialState = function () {
        return {
            cells: [],
            cellSize: [0, 0],
        };
    };
    Calendar.prototype.getCoordinate = function () {
        return this._coordCalendar;
    };
    Calendar.prototype.beforeRender = function () {
        var _a = this.option, facet = _a.facet, cellSize = _a.cellSize, dateRange = _a.dateRange, firstDay = _a.firstDay;
        var startDate = dateRange[0], endDate = dateRange[1];
        var _b = this.chart.getFacetContentBox(facet), top = _b.top, left = _b.left, right = _b.right, bottom = _b.bottom;
        var labelSize = this.getSideLabelSize();
        top += labelSize.top;
        left += labelSize.left;
        right -= labelSize.right;
        bottom -= labelSize.bottom;
        this._coordCalendar = new CalendarCoordinate({
            x: left,
            y: top,
            width: right - left,
            height: bottom - top,
            cellSize: lodash.isNumber(cellSize) ? [cellSize, cellSize] : cellSize,
            startDate: startDate,
            endDate: endDate,
            firstDay: firstDay,
        });
        this.setState({
            cells: this._coordCalendar.getCells(),
            cellSize: this._coordCalendar.getCellSize(),
        });
    };
    Calendar.prototype.render = function () {
        var group = new Group({
            key: this.getKey('calendar'),
        });
        group.add(this.renderCells());
        if (this.option.dayLabel.show) {
            group.add(this.renderDayLabels());
        }
        if (this.option.monthLabel.show) {
            group.add(this.renderMonthLabels());
        }
        if (this.option.monthBoundary.show) {
            this.chart.addToTopLevel(this.renderMonthBoundary());
        }
        return group;
    };
    Calendar.prototype.getSideLabelSize = function () {
        var _a = this.option, dayLabel = _a.dayLabel, monthLabel = _a.monthLabel;
        var ret = { top: 0, left: 0, right: 0, bottom: 0 };
        if (monthLabel.show) {
            var monthSide = monthLabel.opposite ? 'bottom' : 'top';
            ret[monthSide] = monthLabel.textStyle.fontSize + monthLabel.margin;
        }
        if (dayLabel.show) {
            var dayLabels = this.getDayLabels();
            var daySide = dayLabel.opposite ? 'right' : 'left';
            ret[daySide] =
                lodash.max(dayLabels.map(function (label) { return measureText(label, dayLabel.textStyle).width; })) +
                    dayLabel.margin;
        }
        return ret;
    };
    Calendar.prototype.renderCells = function () {
        var _a = this.state, cells = _a.cells, cellSize = _a.cellSize;
        var group = new Group(__assign({ key: this.getKey('calendar-cells') }, this.option.cellStyle));
        var cellWidth = cellSize[0], cellHeight = cellSize[1];
        cells.forEach(function (cell) {
            var x = cell.x, y = cell.y, date = cell.date;
            group.add(new Rect({
                key: date,
                x: x - cellWidth / 2,
                y: y - cellHeight / 2,
                width: cellWidth,
                height: cellHeight,
            }));
        });
        return group;
    };
    Calendar.prototype.getDayLabels = function () {
        return this.chart.getLocale().calendar.dayOfWeekAbbr;
    };
    Calendar.prototype.renderDayLabels = function () {
        var _a = this.option.dayLabel, opposite = _a.opposite, margin = _a.margin;
        var group = new Group({
            key: this.getKey('calendar-day-labels'),
            fill: 'blue',
        });
        var _b = this._coordCalendar.getBoundingRect(), left = _b.left, right = _b.right;
        var textAlign = opposite ? 'left' : 'right';
        var position = opposite ? right + margin : left - margin;
        var dayLabels = this.getDayLabels();
        for (var i = 0; i < 7; i++) {
            var y = this._coordCalendar.getDayPosition(i);
            group.add(createText(__assign(__assign({ text: dayLabels[i], x: position, y: y }, this.getTextStyle(this.option.dayLabel.textStyle)), { textAlign: textAlign, textBaseline: 'middle' })));
        }
        return group;
    };
    Calendar.prototype.renderMonthLabels = function () {
        var _this = this;
        var _a = this.option.monthLabel, opposite = _a.opposite, margin = _a.margin;
        var cells = this.state.cells;
        var group = new Group({
            key: this.getKey('calendar-month-labels'),
            fill: 'blue',
        });
        var monthList = [];
        var currentMonth = -1;
        var currentItem;
        cells.forEach(function (cell) {
            var week = cell.week, month = cell.month;
            if (month === currentMonth) {
                currentItem.minWeek = Math.min(currentItem.minWeek, week);
                currentItem.maxWeek = Math.max(currentItem.maxWeek, week);
            }
            else {
                currentMonth = month;
                currentItem = { month: month, minWeek: week, maxWeek: week };
                monthList.push(currentItem);
            }
        });
        var weekScale = this._coordCalendar.getWeekScale();
        var _b = this._coordCalendar.getBoundingRect(), top = _b.top, bottom = _b.bottom;
        var position = opposite ? bottom + margin : top - margin;
        var textBaseline = opposite ? 'top' : 'bottom';
        monthList.forEach(function (month) {
            var minWeek = month.minWeek, maxWeek = month.maxWeek;
            var start = weekScale.scale(minWeek);
            var end = weekScale.scale(maxWeek);
            group.add(createText(__assign(__assign({ text: _this.chart.getLocale().calendar.monthAbbr[month.month], x: (start + end) / 2, y: position }, _this.getTextStyle(_this.option.monthLabel.textStyle)), { textAlign: 'center', textBaseline: textBaseline })));
        });
        return group;
    };
    Calendar.prototype.renderMonthBoundary = function () {
        var lineStyle = this.option.monthBoundary.lineStyle;
        var _a = this.state, cells = _a.cells, cellSize = _a.cellSize;
        var cellWidth = cellSize[0], cellHeight = cellSize[1];
        var group = new Group(__assign({ key: this.getKey('calendar-month-boundary') }, lineStyle));
        var weekScale = this._coordCalendar.getWeekScale();
        var maxWeek = Math.floor(weekScale.max);
        var _loop_1 = function (i) {
            var weekCells = cells.filter(function (cell) { return cell.week === i; });
            var firstCell = weekCells[0];
            var lastCell = lodash.last(weekCells);
            var firtCellMonth = weekCells[0].month;
            var hasEdge = weekCells.some(function (cell) { return cell.next && cell.next.month !== firtCellMonth; });
            if (!hasEdge) {
                return "continue";
            }
            var points = [];
            var monthLastDayCellInex = lodash.findIndex(weekCells, function (cell) { var _a; return ((_a = cell.next) === null || _a === void 0 ? void 0 : _a.month) !== firtCellMonth; });
            var turnCell = weekCells[monthLastDayCellInex];
            points.push({
                x: firstCell.x + cellWidth / 2,
                y: firstCell.y - cellHeight / 2,
            });
            if (monthLastDayCellInex !== weekCells.length - 1) {
                points.push({
                    x: turnCell.x + cellWidth / 2,
                    y: turnCell.y + cellHeight / 2,
                });
                points.push({
                    x: turnCell.x - cellWidth / 2,
                    y: turnCell.y + cellHeight / 2,
                });
                points.push({
                    x: lastCell.x - cellWidth / 2,
                    y: lastCell.y + cellHeight / 2,
                });
            }
            else {
                points.push({
                    x: lastCell.x + cellWidth / 2,
                    y: lastCell.y + cellHeight / 2,
                });
            }
            group.add(new Polyline({
                pointList: points,
            }));
        };
        for (var i = 0; i < maxWeek; i++) {
            _loop_1(i);
        }
        return group;
    };
    return Calendar;
}(ComponentModel));
export default Calendar;
